export const saVersionListConstants = {
  SAVERSION_LIST_LOADING: "SAVERSION_LIST_LOADING",
  SAVERSION_LIST_SUCCESS: "SAVERSION_LIST_SUCCESS",
  SAVERSION_LIST_FAILURE: "SAVERSION_LIST_FAILURE",
};

export const saVersionUploadConstants = {
  SAVERSION_UPLOAD_LOADING: "SAVERSION_UPLOAD_LOADING",
  SAVERSION_UPLOAD_SUCCESS: "SAVERSION_UPLOAD_SUCCESS",
  SAVERSION_UPLOAD_FAILURE: "SAVERSION_UPLOAD_FAILURE",
};

export const saVersionConstants = {
  SAVERSION_LOADING: "SAVERSION_LOADING",
  SAVERSION_SUCCESS: "SAVERSION_SUCCESS",
  SAVERSION_FAILURE: "SAVERSION_FAILURE",
};

export const saVersionDeleteConstants = {
  SAVERSION_DELETE_LOADING: "SAVERSION_DELETE_LOADING",
  SAVERSION_DELETE_SUCCESS: "SAVERSION_DELETE_SUCCESS",
  SAVERSION_DELETE_FAILURE: "SAVERSION_DELETE_FAILURE",
};
